

function sliderbuttons(){
  document.querySelectorAll('.category__button').forEach(button=>{button.style.opacity="1"})
  document.querySelector('div.swiper-pagination').style.opacity="1";
  document.querySelector('.menubtnMobile').style.opacity="1";
}

  
  
document.querySelectorAll('[data-menu="special-menu-men"]').forEach(menuItem => {
  menuItem.addEventListener('click', () => {
      var menstab = document.querySelectorAll('[data-next="mens"]');
      if (menstab) {
          menstab.forEach(mentabs => {
              if (mentabs) {
                  mentabs.click();
                  sliderbuttons();
              }
          });
      }
  });
});

document.querySelectorAll('[data-menu="special-menu-women"]').forEach(menuItem => {
  menuItem.addEventListener('click', () => {
      var womentab = document.querySelectorAll('[data-next="women"]');
      if (womentab) {
          womentab.forEach(womentabs => {
              if (womentabs) {
                  womentabs.click();
                  sliderbuttons();
              }
          });
      }
  });
});

document.querySelectorAll('[data-menu="special-menu-kids"]').forEach(menuItem => {
  menuItem.addEventListener('click', () => {
      var juniorstab = document.querySelectorAll('[data-next="juniors"]');
      if (juniorstab) {
          juniorstab.forEach(juniorstabs => {
              if (juniorstabs) {
                  juniorstabs.click();
                  sliderbuttons();
              }
          });
      }
  });
});



